import { Stage } from '@eventbrite/webapp-constants';
import { StatsigEnvTier } from './types';

export const STATSIG_ENV = {
  PROD: 'production',
  QA: 'staging',
  DEV: 'development',
} as const;

const STAGE_TO_STATSIG_ENV: Partial<Record<Stage, StatsigEnvTier>> = {
  [Stage.PROD]: STATSIG_ENV.PROD,
  [Stage.TEST]: STATSIG_ENV.QA,
  [Stage.DEV]: STATSIG_ENV.DEV,
  [Stage.LOCAL]: STATSIG_ENV.DEV,
};

export const getStatsigEnvFromStage = (stage: Stage): StatsigEnvTier | undefined =>
  STAGE_TO_STATSIG_ENV[stage];
